function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M48.7,29.418c12.77,0,19.718-10.516,19.718-19.718V8.761A15.265,15.265,0,0,0,71.8,5.192a15.589,15.589,0,0,1-3.944,1.127,7.306,7.306,0,0,0,3-3.756,17.225,17.225,0,0,1-4.319,1.69A6.707,6.707,0,0,0,61.474,2a7.056,7.056,0,0,0-6.948,6.948,3.661,3.661,0,0,0,.188,1.5A19.416,19.416,0,0,1,40.441,3.127,7.192,7.192,0,0,0,39.5,6.695a7.461,7.461,0,0,0,3,5.822,6.331,6.331,0,0,1-3.192-.939h0a6.863,6.863,0,0,0,5.634,6.761,5.789,5.789,0,0,1-1.878.188,3.2,3.2,0,0,1-1.315-.188,7.114,7.114,0,0,0,6.573,4.883,14.179,14.179,0,0,1-8.638,3A5.2,5.2,0,0,1,38,26.038a17.726,17.726,0,0,0,10.7,3.38",
  transform: "translate(-38 -2)",
  fill: "#191a1e",
  fillRule: "evenodd"
});

function SvgTwt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.803,
    height: 27.418,
    viewBox: "0 0 33.803 27.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwt);
export default __webpack_public_path__ + "static/media/Twt.9f00cf4e.svg";
export { ForwardRef as ReactComponent };